import { createContext, useContext } from "react";
import { WPPost } from "../constants/types";
import { ListingAcf } from "../constants/types/acf";
import { useGlobalAcf } from "../services/app-state";

export enum Communities {
    lgbtq = "lgbtq",
    atsi = "atsi",
    multicultural = "multicultural",
    carer = "carer",
    military_personnel_and_veterans = "military_personnel_and_veterans",
    new_and_expecting_parents = "new_and_expecting_parents",
    rural_and_remote_people = "rural_and_remote_people",
}

export const CommunityContext = createContext<undefined | string[]>(undefined);

export const useCommunityForTermId = (
    communityTermId: number | undefined,
): Communities | undefined => {
    const [
        {
            mappings: {
                community_mappings: { atsi, lgbtq, faith_based_or_community_group, carer, military_personnel_and_veterans, new_and_expecting_parents, rural_and_remote_people },
            },
        },
    ] = useGlobalAcf();

    switch (communityTermId) {
        case atsi:
            return Communities.atsi;
        case lgbtq:
            return Communities.lgbtq;
        case faith_based_or_community_group:
            return Communities.multicultural;
        case carer:
            return Communities.carer;
        case military_personnel_and_veterans:
            return Communities.military_personnel_and_veterans;
        case new_and_expecting_parents:
            return Communities.new_and_expecting_parents;
        case rural_and_remote_people:
            return Communities.rural_and_remote_people;
    }

    return undefined;
};

export const useCommunityTermId = (community: Communities | undefined): number | undefined => {
    const [
        {
            mappings: {
                community_mappings: { atsi, lgbtq, faith_based_or_community_group, carer, military_personnel_and_veterans, new_and_expecting_parents, rural_and_remote_people },
            },
        },
    ] = useGlobalAcf();

    switch (community) {
        case Communities.atsi:
            return atsi;
        case Communities.lgbtq:
            return lgbtq;
        case Communities.multicultural:
            return faith_based_or_community_group;
        case Communities.carer:
            return carer;
        case Communities.military_personnel_and_veterans:
            return military_personnel_and_veterans;
        case Communities.new_and_expecting_parents:
            return new_and_expecting_parents;
        case Communities.rural_and_remote_people:
            return rural_and_remote_people;
        default:
            return undefined;
    }
};

export const useCommunityContext = () => {
    const communityContext = useContext(CommunityContext);
    let communityTermId = 0;
    if (communityContext?.length && communityContext?.length == 1) {
        communityTermId = parseInt(communityContext[0] ?? 0);
    }
    const community = useCommunityForTermId(communityTermId);
    return { community, communityTermId };
};

export const useCommunitySpecificBlurb = (post: WPPost<ListingAcf>) => {
    const { communityTermId } = useCommunityContext();
    const blurb = post.acf.meta.communities_descriptions
        ? post.acf.meta.communities_descriptions.find(cd => cd.community === communityTermId)
              ?.description
        : undefined;
    return blurb;
};
